import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import { useTranslation } from 'react-i18next';

import { statusColors } from '../Constants/constants';

const useStyles = makeStyles((theme) => ({
  connection: {
    alignItems: 'center',
    boxSizing: 'border-box',
    color: theme.palette.common.white,
    display: 'inline-flex',
    fontSize: '0.75em',
    fontWeight: 700,
    height: '1.1em',
    justifyContent: 'center',
    lineHeight: 1,
    borderRadius: '50%',
    margin: '1em',
    width: '1.1em'
  }
}));

export function ConnectionStatus({ slave, ahu_status = undefined, controllerStatus }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const statusUnknown = controllerStatus !== 'good';
  const connectionStatus = statusUnknown
    ? 'unknown'
    : ahu_status !== undefined
      ? ahu_status === 1
        ? 'good'
        : ahu_status === 0
          ? 'bad'
          : 'issues'
      : slave?.status === 'active'
        ? 'good'
        : slave?.status === 'inactive'
          ? 'bad'
          : 'issues';

  const unknownLabel = t('connection_status_unknown');

  return (
    <Tooltip title={statusUnknown ? unknownLabel : ''}>
      <span
        role="status"
        aria-label={statusUnknown ? unknownLabel : `Connection status: ${connectionStatus}`}
        className={classes.connection}
        style={{
          backgroundColor: statusColors[connectionStatus]
        }}
      >
        {statusUnknown && <span aria-hidden="true">?</span>}
      </span>
    </Tooltip>
  );
}
